import { initializeApp } from 'firebase/app';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { getFirestore, connectFirestoreEmulator, collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Define a type for high score
export interface HighScore {
  name: string;
  score: number;
  model: string;
  visionEnabled: boolean;
  date: string;
}

const firebaseConfig = {
    apiKey: "AIzaSyAc2jtfBXJlXo8BIJjoy8JfH0QYTZhXibo",
    authDomain: "chess-llm-app.firebaseapp.com",
    projectId: "chess-llm-app",
    storageBucket: "chess-llm-app.firebasestorage.app",
    messagingSenderId: "537531537440",
    appId: "1:537531537440:web:55b5170c030e8782c98445",
    measurementId: "G-Q7NT1CQDC7"
  };


export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// Set region for functions only in production
const isLocalEnvironment = process.env.NODE_ENV === 'development' || (typeof window !== 'undefined' && window.location.hostname === 'localhost');
export const functions = isLocalEnvironment ? getFunctions(app) : getFunctions(app, "europe-west1");

// Inizializza Firebase
const analytics = getAnalytics(app);

// Check if we're in development mode to use emulators
if (isLocalEnvironment) {
  console.log('Using Firebase emulators');
    
  // Connect to Firestore emulator
  connectFirestoreEmulator(db, 'localhost', 8080);
  
  // Connect to Functions emulator
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// High score functions
export async function getHighScores(): Promise<HighScore[]> {
  try {
    // Direct Firestore query instead of Cloud Function
    const highScoresRef = collection(db, 'highScores');
    const q = query(highScoresRef, orderBy('score', 'desc'), limit(10));
    const querySnapshot = await getDocs(q);
    
    const highScores: HighScore[] = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      highScores.push({
        name: data.name || 'Unknown',
        score: data.score || 0,
        model: data.model || 'Unknown',
        visionEnabled: data.visionEnabled || false,
        date: data.date || new Date().toISOString()
      });
    });
    
    return highScores;
  } catch (error) {
    console.error('Error fetching high scores directly from Firestore:', error);
    return [];
  }
}

export async function submitHighScore(name: string, score: number, model: string, visionEnabled: boolean): Promise<boolean> {
  try {
    const submitHighScoreFunction = httpsCallable(functions, 'submit_high_score');
    const result = await submitHighScoreFunction({ name, score, model, visionEnabled });
    const data = result.data as any;
    
    if (!data.success) {
      console.error('Error submitting high score:', data.error);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error calling submit high score function:', error);
    return false;
  }
}

// Add a function specifically for warming up the make_move function
export async function warmupMakeMoveFunction() {
  try {
    const makeMoveFunction = httpsCallable(functions, 'make_move');
    await makeMoveFunction();
    console.log('Successfully warmed up make_move function');
  } catch (error) {
    console.error('Error warming up make_move function:', error);
  }
}
